export interface Log {
    message: string;
    level: LogLevel;
}

export enum LogLevel {
    error,
    information,
    debug
}

export interface LogState {
    logs: Log[];
    logLevels: string
}
